import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  padding: 0 20px;
  display: flex;
  flex-direction: column;

  .ModelCard-wrapper {
    > div {
      background-color: #000;
    }
  }
`;

export const Content = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 20px;
  margin-bottom: 20px;
`;
